/**
 * The published list prices (Tappd business plan, locked 2026-09-24) as a stable module of
 * their own, for every place that shows prices before (or instead of) GET /api/slots/tiers:
 * the redesign's pricing calculator (components/site/pricing usePricingTiers) today, the
 * Pricing page in Phase 3.
 *
 * One source of truth: the rows still live in lib/slotPricing.js (PricingSlot.jsx and the
 * Phase 5c copy guard import them from there), and this module re-exports them. When the
 * last importer of `slotPricing.PUBLISHED_SLOT_TIERS` moves here, the definition can move
 * here too (and slotPricing re-export it) without changing any caller of this module.
 * Same field names as GET /slots/tiers; used only when the API has no slot tiers (404,
 * empty list), never mixed with live rows.
 */
import { PAID_SLOT_TIERS, PUBLISHED_SLOT_TIERS } from './slotPricing';

export { PUBLISHED_SLOT_TIERS };

/** The published paid tiers (Standard, Premium, Venue Sponsor), in display order. */
export const PUBLISHED_PAID_SLOT_TIERS = Object.freeze(
  PUBLISHED_SLOT_TIERS.filter((t) => PAID_SLOT_TIERS.includes(t.tier_key)),
);
